import "../phaser.min.js";
import Common from "../Includes/Common.js";
import Deer from "./Deer";
class MountainBackground extends Phaser.Scene {
    constructor() {
        super('MountainBackground');
        this.common = new Common();
    }

    init(data) {
        this.scrollSpeed = data.scrollSpeed;
        this.bgEvents = [
            ['happy', 'hogs'],
            ['exclamation','birds'],
            ['exclamation', 'hawksbill'],
            ['happy','fog'],
            ['sasquatch'],
            ['happy', 'possums'],
            ['sixseven','hogs'],
            ['happy', 'deer'],
        ];
        this.eventQueue = structuredClone(this.bgEvents);
        this.deerScene = null;
        this.moveSas = false;
        this.fogFlag = false;
    }

    preload() {
        this.load.atlas('bigfoot', this.common.assetsPath + 'sprites/sasquatch.png', this.common.assetsPath + 'sprites/sasquatch.json');
    }

    create() {
        this.lights.enable();
        const light = this.lights.addLight(this.scale.width / 2, 100, 9000, 0xffffff, 1);
        this.sasSFX = this.sound.add('sas', {volume: this.common.blipVolume, detune: -500})
        this.flap1SFX = this.sound.add('flap1', {volume: this.common.blipVolume})
        this.flap2SFX = this.sound.add('flap2', {volume: this.common.blipVolume})
        this.flap3SFX = this.sound.add('flap3', {volume: this.common.blipVolume})
        this.flap4SFX = this.sound.add('flap4', {volume: this.common.blipVolume})

        this.sky = this.add.tileSprite(0, 0, this.scale.width, 105, 'level', 'sky1')
                .setOrigin(0, 0)
                .setScale(this.common.gameScale).setLighting(true)

        this.furthestBackground = this.add.tileSprite(0, 150, this.scale.width, 73, 'level', 'furthest-background')
                .setOrigin(0, 0)
                .setScale(this.common.gameScale).setLighting(true)

        this.birds = this.add.tileSprite(0, 0, this.scale.width, 600, 'level', 'birds')
                .setOrigin(0, 0)
                .setScale(this.common.gameScale)
                .setAlpha(0).setLighting(true)

        this.cliffPoint = this.add.tileSprite(0, 0, this.scale.width, 100, 'level', 'cliff-point').setOrigin(0, 0)
                .setScale(this.common.gameScale)
                .setAlpha(0).setLighting(true)

        this.fog = this.add.tileSprite(0, 60, this.scale.width , 36, 'level', 'fog')
                .setOrigin(0, 0)
                .setScale(this.common.gameScale).setLighting(true)

        this.middleHillTrees = this.add.tileSprite(0, 100, this.scale.width, 103, 'level', 'middle-hill-trees')
                .setOrigin(0, 0)
                .setScale(this.common.gameScale).setLighting(true)

        this.fog2 = this.add.tileSprite(0, 60, this.scale.width , 36, 'level', 'fog')
                .setOrigin(0, 0)
                .setScale(this.common.gameScale * 2).setLighting(true)

        this.backgroundTrees = this.add.tileSprite(0, 225, this.scale.width, 60, 'level', 'background-trees')
                .setOrigin(0, 0)
                .setScale(this.common.gameScale).setLighting(true)

        this.sasquatch = this.add.sprite(this.scale.width + 100, 100 * 4, 'bigfoot', 0)
                .setScale(this.common.gameScale)

        this.road = this.add.tileSprite(0, 184, 980, 90, 'level', 'road-grass')
                .setOrigin(0, 0)
                .setScale(this.common.gameScale).setLighting(true)

        this.foreground = this.add.tileSprite(0, 544, this.scale.width, 134, 'level', 'foreground')
                .setOrigin(0, 0)
                .setScale(this.common.gameScale).setLighting(true)

        this.hogs = this.add.group();
        this.possums = this.add.group();
        if(!this.anims.exists('walk')) {
            this.anims.create({
                key: 'walk',
                frames: this.anims.generateFrameNames('bigfoot', {
                    prefix: 'sasquatch ',
                    start: 0,
                    end: 7,
                    zeroPad: 0,
                    suffix: '.aseprite'
                }),
                frameRate: 4,
                repeat: -1 // -1 means infinite looping
            });
        }
        this.sasquatch.play('walk')

        this.addEventListeners();
    }

    quizEventHandler() {
        const quiz = this.scene.get('Quiz');
        quiz.events.on('scroll-speed-changed', (data) => {
            this.scrollSpeed = data.scrollSpeed;
        }, this)


        quiz.events.on('reset', () => {
            this.bgEvents = structuredClone(this.eventQueue);
            if(this.hogs && this.hogs.getChildren().length > 0) {
                this.hogs.getChildren().forEach(hog => {
                    hog.destroy();
                })
            }
            if(this.possums && this.possums.getChildren().length > 0) {
                this.possums.getChildren().forEach(possum => {
                    possum.destroy();
                })
            }
            if(this.birds) {
                this.birds.setAlpha(0);
            }
            if(this.cliffPoint) {
                this.cliffPoint.setAlpha(0);
            }

            if(this.deerScene) {
                this.deerScene.removeDeer();
                this.deerScene.readyToCreateAnimals = true;
            }

        })
    }

    carEventHandler = () => {
        this.car = this.scene.get('Car')
        this.events.on('love', () => {
            this.car.showEmote('heart-emote')
        }, this)

        this.events.on('happy', () => {
            this.car.showEmote('happy-emote')
        }, this)

        this.events.on('sixseven', () => {
            this.car.showEmote('67-emote')
        }, this)

        this.events.on('bigfoot', ()=>{
            this.sasquatch.x = this.scale.width + 100;
            this.sasquatch.setVisible(true);
            this.car.showEmote('bigfoot-emote')
        }, this)

        this.events.on('exclamation', ()=>{
            this.car.showEmote('exclamation-emote')
        })

        this.events.on('moo', () =>  {
            this.car.showEmote('moo-emote')
        })

        this.events.on('bruh', () => {
            this.car.showEmote('bruh-emote')
        })
    }

    addEventListeners = () => {
        if(this.scene.get('Quiz')) {
            this.quizEventHandler();
        }

        if(this.scene.get('Car')) {
            this.carEventHandler();
        }

        this.events.on('birds', () => {

            this.flap1SFX.play();
            this.flap2SFX.play({
                delay: 0.4, loop: true
            });
            this.flap3SFX.play({
                delay: 0.8, loop: true
            });
            this.flap4SFX.play({
                delay: 1.5, loop: true
            });

            this.tweens.add({
                targets: this.birds,
                alpha: 1,
                duration: 1000,
                ease: 'Linear',
                yoyo: false,
                repeat: 0,
            })

            this.tweens.add({
                targets: [this.flap1SFX, this.flap2SFX, this.flap3SFX, this.flap4SFX],
                volume: 0,
                duration: 1000,
                delay: 3000,
            })
        })

        this.events.on('hawksbill', () => {
            this.tweens.add({
                targets: this.cliffPoint,
                alpha: 1,
                duration: 1000,
                ease: 'Linear',
                yoyo: false,
                repeat: 0,
            })
        })

        this.events.on('fog', () => {
            this.tweens.add({
                targets: this.fog2,
                alpha: 0,
                duration: 1200,
                ease: 'Linear',
                yoyo: false,
                repeat: 0,
            });
        })

        this.events.on('hogs', () => {
            const min = this.scale.height/12 * 8;
            const max = this.scale.height/12 * 8.5;
            const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;


            this.newHogs = this.hogs.create(this.scale.width, randomNumber + 30, 'level', 'hog')
                    .setOrigin(0.5, 1).setScale(6)

            this.tweens.chain({
                targets: this.newHogs,
                tweens: [
                    {
                        y: randomNumber,
                        scaleY: 6.6,
                        scaleX: 4,
                        duration: 100,
                        ease: 'Power2'
                    },
                    {
                        scaleY: 6,
                        scaleX: 6,
                        duration: 150,
                        ease: 'Back.easeOut'
                    }
                ]
            })
        })

        this.events.on('possums', () => {
            const min = this.scale.height/12 * 11;
            const max = this.scale.height/12 * 11.8;
            const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;


            this.newPossum = this.possums.create(this.scale.width, randomNumber + 30, 'level', 'hogs')
                    .setOrigin(0.5, 1).setScale(6)

            this.tweens.chain({
                targets: this.newPossum,
                tweens: [
                    {
                        y: randomNumber,
                        scaleY: 6.6,
                        scaleX: 4,
                        duration: 100,
                        ease: 'Power2'
                    },
                    {
                        scaleY: 6,
                        scaleX: 6,
                        duration: 150,
                        ease: 'Back.easeOut'
                    }
                ]
            })
        })

        this.events.on('deer', ()=>{
            if(!this.deerScene) {
                if(!this.scene.get('Deer')) {
                    this.scene.add('Deer', Deer)
                }
                this.scene.launch('Deer', {scrollSpeed: this.scrollSpeed, baseSpeed: 1.2, y: this.scale.height / 12 * 9})
                this.scene.moveBelow('Question', 'Deer')
                this.deerScene = this.scene.get('Deer');
            }else{
                this.deerScene.addDeer();
            }
        })

        this.events.on('sasquatch', () => {
            this.moveSas = true;
            this.sasSFX.play();
            this.car.showEmote('bigfoot-emote')
        })


        const backgroundManager = this.scene.get('BackgroundManager');
        backgroundManager.events.on('MountainBackground-fire-background-event', () => {
            let bgEvent = this.bgEvents.pop();
            if(Array.isArray(bgEvent)) {
                bgEvent.forEach(event => {
                    this.events.emit(event);
                })
            }else{
                this.events.emit(bgEvent);
            }
        })

        backgroundManager.events.on('MountainBackground-fade-out', () => {
            this.add.tween({
                targets: [this.sky, this.furthestBackground, this.cliffPoint, this.fog, this.middleHillTrees, this.backgroundTrees, this.road, this.foreground, this.birds].concat(this.hogs.getChildren() ?? []).concat(this.possums.getChildren() ?? []),
                alpha: 0,
                duration: 2000,
                ease: 'Linear',
                yoyo: false,
                repeat: 0,
                onComplete: () => {
                    this.scene.sleep(this)
                }
            })
        }, this)
    }

    update(time, delta) {
        let deltaSeconds = delta / 1000;
        this.sky.tilePositionX += this.scrollSpeed * 0.05 * deltaSeconds;
        this.birds.tilePositionX -= this.scrollSpeed * 0.125 * deltaSeconds;
        this.birds.tilePositionY += this.scrollSpeed * 0.25 * deltaSeconds;
        this.furthestBackground.tilePositionX += this.scrollSpeed * 0.125 * deltaSeconds;
        this.cliffPoint.tilePositionX += this.scrollSpeed * 0.33 * deltaSeconds;
        this.fog.tilePositionX += this.scrollSpeed * 0.25 * deltaSeconds;
        this.middleHillTrees.tilePositionX += this.scrollSpeed * 0.33 * deltaSeconds;
        this.fog2.tilePositionX += this.scrollSpeed * 0.25 * deltaSeconds;
        this.backgroundTrees.tilePositionX += this.scrollSpeed * 0.65 * deltaSeconds;
        this.road.tilePositionX += this.scrollSpeed * deltaSeconds;
        this.foreground.tilePositionX += this.scrollSpeed * 1.2 * deltaSeconds;


        if(this.fogFlag) {
            this.fog.alpha -= 0.05 * deltaSeconds;
        } else {
            this.fog.alpha += 0.05 * deltaSeconds;
        }
        if(this.fog.alpha >= 1) {
            this.fogFlag = true;
        }
        if(this.fog.alpha <= 0){
            this.fogFlag = false;
        }

        if(this.sasquatch && this.moveSas) {
            this.sasquatch.x -= (this.scrollSpeed * 0.6 * this.common.gameScale * deltaSeconds);
            if (this.sasquatch.x < -200) {
                this.sasquatch.setVisible(false);
            }
        }

        if(this.hogs) {
            let children = this.hogs.getChildren();
            let odd = true;
            for(let child of children) {
                child.x -= this.scrollSpeed * 1.2 * this.common.gameScale * deltaSeconds;
                if (child.x < -100 * this.common.gameScale) {
                    child.x = this.scale.width * 1.2;
                }
                odd = !odd;
            }
        }
        if(this.possums) {
            let children = this.possums.getChildren();
            let odd = true;
            for(let child of children) {
                child.x -= this.scrollSpeed * 1.2 * this.common.gameScale * deltaSeconds;
                if (child.x < -100 * this.common.gameScale) {
                    child.x = this.scale.width * 1.2;
                }
                odd = !odd;
            }
        }

    }
}

export default MountainBackground;